module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    attrs: {
      "offset": 4,
      "span": 16
    }
  }, [_c('logo', {
    attrs: {
      "title": _vm.title,
      "primary-color": _vm.primaryColor
    }
  }), _vm._v(" "), (_vm.state === 'reset') ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('p', [_vm._v("To reset your password, enter a new password below.")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "margin": "auto",
      "width": "90%"
    },
    attrs: {
      "role": "presentation",
      "aria-hidden": "true",
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left",
      "font-weight": "bold",
      "padding": "1.2em 0.8em"
    }
  }, [_vm._v("\n            NEW PASSWORD"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pw_new1),
      expression: "pw_new1"
    }],
    staticClass: "input password-input",
    staticStyle: {
      "margin": "auto",
      "width": "90%",
      "border-style": "none none solid none",
      "border-bottom-color": "rgb(210, 210, 210)"
    },
    attrs: {
      "placeholder": "Enter your new password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.pw_new1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pw_new1 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left",
      "font-weight": "bold",
      "padding": "1.2em 0.8em"
    }
  }, [_vm._v("\n            RETYPE NEW PASSWORD"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pw_new2),
      expression: "pw_new2"
    }],
    staticClass: "input password-input",
    staticStyle: {
      "margin": "auto",
      "width": "90%",
      "border-style": "none none solid none",
      "border-bottom-color": "rgb(210, 210, 210)"
    },
    attrs: {
      "placeholder": "Retype your new password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.pw_new2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pw_new2 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [(_vm.reset_error1) ? _c('td', {
    staticClass: "reset_error"
  }, [_c('h3', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Password too short or too long.")]), _vm._v("\n            Passwords must be between 8-20 characters.\n          ")]) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.reset_error2) ? _c('td', {
    staticClass: "reset_error"
  }, [_c('h3', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Passwords not matching.")]), _vm._v("\n            Make sure your new passwords match.\n          ")]) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.reset_error3) ? _c('td', {
    staticClass: "reset_error"
  }, [_c('h3', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Server error.")]), _vm._v("\n            Please try again later.\n          ")]) : _vm._e()])]), _vm._v(" "), _c('button', {
    style: ({
      background: _vm.primaryColor,
      'border-color': _vm.primaryColor
    }),
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Reset Password")])]) : _vm._e(), _vm._v(" "), (_vm.state === 'expired') ? _c('p', [_vm._v("Your link expires after 24 hours or once a new password is set. If you still wish to reset your password, please use the mobile app to request a new password reset link.")]) : _vm._e(), _vm._v(" "), (_vm.state === 'done') ? _c('p', [_vm._v("Please reopen the myProduct app and try logging into your account.")]) : _vm._e(), _vm._v(" "), _c('company', {
    attrs: {
      "name": _vm.footer.companyName,
      "url": _vm.footer.companyUrl,
      "address": _vm.footer.companyAddress,
      "contact": _vm.footer.companyContact,
      "primary-color": _vm.primaryColor
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-effde368","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/assets/pages/Reset/Reset.vue
// module id = 986
// module chunks = 3